// extracted by mini-css-extract-plugin
module.exports = {"footer":"FooterDoc_footer__2uHlu","btn":"FooterDoc_btn__eJNra","btnCancel":"FooterDoc_btnCancel__2ml-K","btnSave":"FooterDoc_btnSave__3015g"};